export { default as UserSVG } from './user.svg';
export { default as EmailSVG } from './email.svg';
export { default as PhoneSVG } from './phone.svg';
